import Noticias from "views/Noticias/Noticias";
import Inscripcion from "views/Inscripcion/Inscripcion";
import Admision from "views/Admision/Admision";
import Perfil from "views/Perfil/Perfil";
import EstadoDeCuenta from "views/EstAdmin/EstadoDeCuenta";

/* import MainAcademicosEst from "../views/EstAcademicos/MainAcademicosEst"; */
import MainConsultasEst from "../views/EstConsultas/MainConsultasEst";
import MainSolicitudesEst from "../views/EstSolicitudes/MainSolicitudesEst";


const Estudiante = [
  {
    path: "/noticias",
    name: "Noticias",
    icon: "pe-7s-news-paper",
    component: Noticias,
    color:"#424242"
  },
  {
    path: "/perfil",
    name: "Perfil",
    icon: "pe-7s-search",
    component: Perfil,
    color:"#424242"
  },
  {
    path: "/inscripcion",
    name: "Inscripción",
    icon: "pe-7s-id",
    component: Inscripcion,
    color:"#424242"
  },
  {
    path: "/cuenta",
    name: "Estado de Cuenta",
    icon: "pe-7s-credit",
    component: EstadoDeCuenta,
    color:"#424242"
  },
  {
    path: "/est_consultas",
    name: "Consultas",
    icon: "pe-7s-search",
    component: MainConsultasEst,
    color:"#424242"
  },
  {
    path: "/est_solicitudes",
    name: "Solicitudes",
    icon: "pe-7s-copy-file",
    component: MainSolicitudesEst,
    color:"#424242"
  },
  {
    path: "/Home",
    name: "Inicio",
    icon: "pe-7s-home",
    component: Noticias,
    color:"#424242"
  }
  /* {
    path: "/admision",
    name: "Admisión",
    icon: "pe-7s-note2",
    component: Admision,
    color:"#424242"
  }, */
];

export default Estudiante;




// WEBPACK FOOTER //
// ./src/routes/Estudiante.jsx